import React from 'react';
import { lyuben, daliya } from '../utils/doctorInfo';
import DoctorTimeline from '../components/DoctorTimeline';

const doctors = { lyuben, daliya };

function Doctor({ name = "lyuben" }) {
    const doctor = doctors[name];

    return (
        <DoctorTimeline
            direction="reverse"
            doctorName={doctor.doctorName}
            doctorImage={doctor.doctorImage}
            doctorDescription={doctor.doctorDescription}
            timelineEvents={doctor.timelineEvents}
        />
    );
}

export default Doctor;